import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "./utilityFunction"

// Initial State
const initialState = {
    fetchClient: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveClient: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchClientData = createApiThunk("client","fetch")
export const saveClientData = createApiThunk("client","save")

// Slice
const clientSlice = createSlice({
    name: "client",
    initialState,

    reducers: {
        resetClientState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchClient = {
                    ...state.fetchClient, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveClient = {
                    ...state.saveClient, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchClientData.pending, (state) => updateState(state, "pending", "fetchClient"))
            .addCase(fetchClientData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchClient", action.payload.data))
            .addCase(fetchClientData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchClient", action.payload))
            // Save data
            .addCase(saveClientData.pending, (state) => updateState(state, "pending", "saveClient"))
            .addCase(saveClientData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveClient", action.payload.data))
            .addCase(saveClientData.rejected, (state, action) =>
                updateState(state, "rejected", "saveClient", action.payload));
    },
});

export const { resetClientState } = clientSlice.actions;
export default clientSlice.reducer;
